// extracted by mini-css-extract-plugin
export var container = "_bi-0";
export var outlet = "_bi-1";
export var outletEnter = "_bi-2";
export var outletEnterActive = "_bi-3";
export var outletExit = "_bi-4";
export var outletExitActive = "_bi-5";